"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var combobox_option_1 = require("../../../combobox-option");
var filter_type_1 = require("./filter-type");
/**
 * A specialized extension of {@link ComboboxOption} class that uses {@link FilterType} as main identifying value and
 * a corresponding message key for human readable display data.
 * @see MessageService
 */
var FilterTypeOption = /** @class */ (function (_super) {
    __extends(FilterTypeOption, _super);
    /**
     * Constructs the option based on the input parameters.
     * @param {!FilterType} value - The method of filtering.
     * @param {boolean} [isDefault=false] - Whether this option should be the default one.
     */
    function FilterTypeOption(value, isDefault) {
        if (isDefault === void 0) { isDefault = false; }
        var _this = _super.call(this, value, FilterTypeOption.NAME_MESSAGE_KEY_PREFIX + filter_type_1.FilterType[value]) || this;
        _this.value = value;
        _this.isDefault = isDefault;
        return _this;
    }
    /**
     * Acts like a copy-constructor: creates new instance based on another one.
     * @param {!FilterTypeOption} filterTypeOption - The source option.
     * @returns {FilterTypeOption} Newly created duplicate of the option provided.
     */
    FilterTypeOption.from = function (filterTypeOption) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterTypeOption);
        return new FilterTypeOption(filterTypeOption.value, filterTypeOption.isDefault);
    };
    /**
     * The message key prefix to be used for display value.
     * @type {string}
     */
    FilterTypeOption.NAME_MESSAGE_KEY_PREFIX = 'reporting.controls.filter.type.';
    return FilterTypeOption;
}(combobox_option_1.ComboboxOption));
exports.FilterTypeOption = FilterTypeOption;
//# sourceMappingURL=filter-type-option.js.map